import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-calc-buyer',
  templateUrl: './calc-buyer.component.html',
  styleUrls: ['./calc-buyer.component.css']
})
export class CalcBuyerComponent implements OnInit {

  @ViewChild('selectRegion', {static: false}) public selectRegion: ElementRef;
  @ViewChild('selectCount', {static: false}) public selectCount: ElementRef;
  @ViewChild('selectCountSell', {static: false}) public selectCountSell: ElementRef;
  @ViewChild('selectNz', {static: false}) public selectNz: ElementRef;
  @ViewChild('btn', {static: false}) public btn: ElementRef;
  @ViewChild('divFBuy', {static: false}) public firstFBuy: ElementRef;
  @ViewChild('divSBuy', {static: false}) public secondSBuy: ElementRef;

  formErrors = {
    "depreg": "",
    "deptsc": "",
    "number": "",
    "depregcomb": "",
    "reg-comb-count": "",
    "gender": "",
    "nz": ""
  };

  validationMessages = {
    "depreg": {
      "required": "Обов'якове поле.",
    },
    "depregcomb": {
      "required": "Обов'якове поле.",
    },
    "reg-comb-count": {
      "required": "Обов'якове поле.",
    },
    "number": {
      "required": "Обов'якове поле.",
      "pattern": "Має бути ціле число.              ",
      "maxlength": "Максимум 4 числа.              ",
      "captchaValidator": "Підтвердіть Recaptcha додатково.",
    },
    "gender": {
      "pattern": "Обов'якове поле.",
    },
    "nz": {
      "pattern": "Обов'якове поле.",
    },
  };


  private DataRegion:any = [
    {
      seo_val: 0,
      text_val: '———————'
    },
    {
      seo_val: 2,
      text_val: 'Легковий'
    },
    {
      seo_val: 1,
      text_val: 'Вантажний'
    },
    {
      seo_val: 0,
      text_val: 'Автобус'
    },   
    {
    seo_val: 3,
    text_val: 'Мотоцикл'
    }, 
    {
    seo_val: 4,
    text_val: 'Мопед'
    },
    {
    seo_val: 5,
    text_val: 'Причіп (напівпричіп)'
    }
  ]

  private DataCount:any = [
    {
      seo_val: 0,
      text_val: '—————'
    },
    {
      seo_val: '1',
      text_val: 'Так'
    }, 
    {
      seo_val: '0',
      text_val: 'Ні'
    }
  ];

  private DataCountSell:any = [
    {
      seo_val: 0,
      text_val: '—————'
    },
    {
      seo_val: '0',
      text_val: '0'
    },  
    {
      seo_val: '0.05',
      text_val: '1'
    },  
    {
      seo_val: '0.18',
      text_val: '2'
    }, 
    {
      seo_val: '0.18',
      text_val: '3'
    }, 
  ]

  private nzCombination:any = [
    {
      seo_val: 0,
      text_val: 'Оберіть вартість бажаного номерного знаку (з урахуванням ПДВ)'
    }, 
    {
      seo_val: 30000,
      text_val: '36000 грн - із чотирьох однакових цифр'
    }, 
    {
      seo_val: 30000,
      text_val: '36000 грн - послідовні комбінації цифр від 0001 до 0009'
    },
    {
      seo_val: '10000',
      text_val: '12000 грн - із чотирьох цифр, три з яких однакові та розташовані підряд'
    },
    {
      seo_val: '10000',
      text_val: '12000 грн - із чотирьох цифр - двох послідовних пар однакових цифр'
    },
    {
      seo_val: '10000',
      text_val: '12000 грн - з послідовних цифр 0123 або 1234'
    },
    {
      seo_val: '8000',
      text_val: '9600 грн - із чотирьох цифр, що починається з двох нулів, а дві наступні цифри неоднакові'
    },
    {
      seo_val: '4000',
      text_val: '4800 грн - із чотирьох цифр, що містить три однакові цифри, які розташовані не підряд'
    },
    {
      seo_val: '4000',
      text_val: '4800 грн - із чотирьох цифр, з яких однаковими є перша і третя, а також друга і четверта, або перша і четверта, а також друга і третя'
    }
  ]

  getDataRegion() {
    return this.DataRegion;
  }

  getDataCount() {
    return this.DataCount;
  }

  getDataCountSell() {
    return this.DataCountSell;
  }

  getNzComb() {
    return this.nzCombination;
  }

  dropDownDataRegion:any = [];
  dropDownDataCount:any = [];
  dropDownNzComb:any = [];
  dropDownDataCountSell:any = [];

  sum:number = 0;
  num_fain = 0;
  sum_fain = 0;
  result:number = 0;
  fainsDu:number = 0;
  fainsNz:number = 0;
  sellCount:number = 0;
  sellCount_rez:number = 0;
  nz_price:number = 0;
  nz_full:number = 0;
  name:string;
  name_inozemn_vit:string;
  name_cost:string;
  fin_sum:number = 0;

  add_nz_price:number = 336;  // було 180
  svidoc_price:number = 312;  // було 312
  poslug_sum:number = 200;

  arr_poslug_price:number = 0;
  fainsDu_zbir:number = 0;
  fainsDu_rez:number = 0;
  fin_sum_for_seller:number = 0;
  fainsDuArm:number = 0;

  addData: FormGroup;

  constructor(private fb: FormBuilder, private router: Router) { }

  ngOnInit() {

    this.buildFormComb();

    this.dropDownDataRegion = this.getDataRegion();
    this.dropDownDataCount = this.getDataCount();
    this.dropDownNzComb = this.getNzComb();
    this.dropDownDataCountSell = this.getDataCountSell();

    localStorage.removeItem("verified");
    this.name_cost = 'Вкажіть середньоринкову або оціночну варість ТЗ в гривнях';
    document.getElementById('count').style.display = "none";
    // document.getElementById('check-lang').style.display = "none";
    
  }

  resolvedD(captchaResponse: string) {

    if (captchaResponse != '') {

      localStorage.setItem("verified", "true");
      this.addData.controls['number'].updateValueAndValidity();
      this.btn.nativeElement.className = "button_success";
      
    } else { alert('Ooops! Something go wrong!')}
  }

  buildFormComb() {
    this.addData = this.fb.group({
      "depregcomb": ['', [
        Validators.required,           
    ]],
      "number": ['', [
        Validators.required,
        Validators.pattern("\\d+"),
    ]],
      "gender": ['', [
        
    ]],
    "nz": ['', []],
    "reg-comb-count": ['', [ ]]
    });

    this.addData.valueChanges
    .subscribe(data => this.onValueChangeComb(data));

    this.onValueChangeComb();

  }

  onValueChangeComb(data?: any) {

    if (!this.addData) return;
    let form = this.addData;

    for (let field in this.formErrors) {
        this.formErrors[field] = "";
      
        let control = form.get(field);

        if (control && control.dirty && !control.valid) {
            let message = this.validationMessages[field];
            for (let key in control.errors) {
                this.formErrors[field] += message[key] + " ";
            }
        }
    }
  } 

  onOptionsSelectedRegion(value:string) {
    if (+value == 0) {
      document.getElementById('count').style.display = "none";
      document.getElementById('in_ukr_ter').style.display = "none";
      document.getElementById('nz-comb-yn').style.display = "none";
      document.getElementById('choose-nz').style.display = "none";
      this.name_cost = 'Вкажіть середньоринкову або оціночну варість ТЗ в гривнях';
    } else if (+value == 1) {
      document.getElementById('count').style.display = "none";
      document.getElementById('in_ukr_ter').style.display = "none";
      document.getElementById('nz-comb-yn').style.display = "none";
      document.getElementById('choose-nz').style.display = "none";
      this.name_cost = 'Вкажіть середньоринкову або оціночну варість ТЗ в гривнях';
    }
    else if (+value == 2) {
      document.getElementById('count').style.display = "none";
      document.getElementById('in_ukr_ter').style.display = "block";
      document.getElementById('nz-comb-yn').style.display = "block";
      this.name_cost = 'Вкажіть вартість ТЗ з документу, що підтверджує правомірність придбання в гривнях (без ПДВ)';
    } else if (+value == 3) {
      document.getElementById('count').style.display = "block";
      document.getElementById('in_ukr_ter').style.display = "none";
      document.getElementById('nz-comb-yn').style.display = "none";
      document.getElementById('choose-nz').style.display = "none";
      this.name_cost = 'Вкажіть середньоринкову або оціночну варість ТЗ в гривнях';
    }
     else if (+value == 4) {
      document.getElementById('count').style.display = "block";
      document.getElementById('in_ukr_ter').style.display = "none";
      document.getElementById('nz-comb-yn').style.display = "none";
      document.getElementById('choose-nz').style.display = "none";
      this.name_cost = 'Вкажіть середньоринкову або оціночну варість ТЗ в гривнях';
    } 
    else if (+value == 5) {
      document.getElementById('count').style.display = "none";
      document.getElementById('in_ukr_ter').style.display = "none";
      document.getElementById('nz-comb-yn').style.display = "none";
    } else {
      document.getElementById('count').style.display = "none";
      document.getElementById('in_ukr_ter').style.display = "none";
      document.getElementById('nz-comb-yn').style.display = "none";
      document.getElementById('choose-nz').style.display = "none";
      this.name_cost = 'Вкажіть середньоринкову або оціночну варість ТЗ в гривнях';
    }
  }

  onOptionsSelectedReestrTz(value:string) {
    if (+value == 1) {
      document.getElementById('count').style.display = "block";
    } 
    if (+value == 0) {
      document.getElementById('count').style.display = "none";
      this.sellCount_rez = 0;
      this.fainsDu_rez = 0;
      this.selectCountSell.nativeElement.value = 0;
    }
  }

  onOptionsSelectedNz(value:string) {
    if (+value == 1) {
      document.getElementById('choose-nz').style.display = "block";
    } else {
      document.getElementById('choose-nz').style.display = "none";
      this.selectNz.nativeElement.value = 0;
    }
  }

  get myForm() {
    return this.addData.get('gender');
  }

  backMainClicked() {
    /*  this._location.back(); */
    this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
      this.router.navigate(['/']);
    });
    localStorage.removeItem("verified");
  }

  backClicked() {
    /*  this._location.back(); */
    this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
    this.router.navigate(['calculator-buyer']);
    });
    localStorage.removeItem("verified");
  }

  fetchDnzNumb(region:any, count:any, countSell:any, nzMoney:any, money:any) {

    const enterParam: HTMLElement = document.getElementById('first');
    const outData: HTMLElement = document.getElementById('second');

    enterParam.classList.add('animate__animated', 'animate__zoomOut');
    setTimeout(() => enterParam.hidden = true, 900);

    outData.classList.add('animate__animated', 'animate__flipInY');
    setTimeout(() => document.getElementById('second').style.display = 'block', 900);

    let nums = +region;

    if (count == 0) {
      if (money <= 442860)
        this.fainsDu = money*0.03;
      if (money > 442860 && money <=778360)
        this.fainsDu = money*0.04
      if (money > 778360)
        this.fainsDu = money*0.05
    } else {
      this.fainsDu = 0;
    }

    switch (nums) {
      case 0:
          this.fainsDu = 0;
          this.nz_full = this.add_nz_price;
          this.fainsDu_zbir = money * 0.015;
          this.fainsDu_rez = Math.ceil(this.fainsDu_zbir); //військовий збір
          this.name = 'автобуса';
          this.sellCount = money * 0.05;
          this.sellCount_rez = Math.ceil(this.sellCount); //податок від продажу ТЗ
          this.fin_sum_for_seller = this.fainsDu_rez + this.sellCount_rez;
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.sum_fain = Math.ceil(this.arr_poslug_price) + this.add_nz_price + this.svidoc_price;
          this.fin_sum = this.sum_fain;
          break;
      case 1:
          this.fainsDu = money * 0.015;
          this.fainsDu_rez = Math.ceil(this.fainsDu);
          this.sellCount = money * 0.05;
          this.sellCount_rez = Math.ceil(this.sellCount);
          this.fin_sum_for_seller = this.fainsDu_rez + this.sellCount_rez;
          this.nz_full = this.add_nz_price;
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.sum_fain = this.arr_poslug_price + this.add_nz_price + this.svidoc_price;
          this.fin_sum = this.sum_fain;
          this.name = 'вантажного ТЗ';
          break;
      case 2:
          this.num_fain = Math.ceil(this.fainsDu);
          this.sellCount = money * countSell;
          this.sellCount_rez = Math.ceil(this.sellCount);
            if (countSell == 0.05 || countSell == 0.18) 
              this.fainsDuArm = money * 0.015;
            else
              this.fainsDuArm = 0;
  
          this.fainsDu_rez = Math.ceil(this.fainsDuArm);
          this.fin_sum_for_seller = this.fainsDu_rez + this.sellCount_rez;
          this.name = 'легкового ТЗ';
          this.nz_price = +nzMoney;
          this.fainsNz = nzMoney*0.2;
          this.nz_full = this.nz_price + this.fainsNz + this.add_nz_price;
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.sum = +this.arr_poslug_price + this.nz_full + this.svidoc_price;
          this.sum_fain = Math.ceil(this.sum);
          this.fin_sum = this.sum_fain + this.num_fain;
          break;
      case 3:
          this.name = 'мотоцикла';
          this.fainsDu = 0;
          this.nz_full = 111;  // номерний знак, округлено, було 74
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
         
          this.sellCount = money * countSell;
          this.sellCount_rez = Math.ceil(this.sellCount);
          if (countSell == 0.05 || countSell == 0.18) 
            this.fainsDuArm = money * 0.015;
          else
            this.fainsDuArm = 0;

          this.fainsDu_rez = Math.ceil(this.fainsDuArm);
          this.fin_sum_for_seller = this.fainsDu_rez + this.sellCount_rez;

          this.sum_fain = this.arr_poslug_price + this.nz_full + this.svidoc_price;
          this.fin_sum = this.sum_fain;
          break;
      case 4:
          this.name = 'мопеда';
          this.fainsDu = 0;
          this.nz_full = 84;  // номерний знак, округлено, було 60

          this.sellCount = money * countSell;
          this.sellCount_rez = Math.ceil(this.sellCount);
          if (countSell == 0.05 || countSell == 0.18) 
            this.fainsDuArm = money * 0.015;
          else
            this.fainsDuArm = 0;

          this.fainsDu_rez = Math.ceil(this.fainsDuArm);
          this.fin_sum_for_seller = this.fainsDu_rez + this.sellCount_rez;

          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.sum_fain = this.arr_poslug_price + this.nz_full + this.svidoc_price;
          this.fin_sum = this.sum_fain;
          break; 
      case 5:
          this.fainsDu = money * 0.015;
          this.fainsDu_rez = Math.ceil(this.fainsDu);
          this.sellCount = money * 0.05;
          this.sellCount_rez = Math.ceil(this.sellCount);
          this.fin_sum_for_seller = this.fainsDu_rez + this.sellCount_rez;
          this.name = 'причіпа (напівпричіпа)';
          this.nz_full = 101; // номерний знак, округлено, було 90
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.sum_fain = this.arr_poslug_price + this.nz_full + this.svidoc_price;
          this.fin_sum = this.sum_fain;

          this.num_fain = 0;
          break;                                          
      default:
          console.log("No such numb exists!");
          break;
  }

  }

}
